

export interface IOrdersAudit {
    id: number;
    order_id: number;
    data: {
        action: IOrdersAuditAction;
        action_status: string;
        action_data_message: string;
        action_data_id: number;
    }
    message: string;
    created_at: string;
}

export enum IOrdersAuditAction {
    CREATE = 'create', // DONE
    UPDATE = 'update',
    CANCEL = 'cancel', // DONE
    CUSTOMER_CREATE = 'customer_create', // DONE
    CUSTOMER_UPDATE = 'customer_update', // DONE
    LINE_ITEM_SEND_TO_PRINT = 'send_to_print', // DONE
    LINE_ITEM_SCAN = 'line_item_scan', // DONE
    LINE_ITEM_UNSCAN = 'line_item_unscan', // DONE
    WEIGH = 'weigh', // DONE
    INVOICE = 'invoice', // DONE
    SHIP = 'ship', // DONE
    DELIVER = 'deliver',
    COMMENT = 'comment',
    RESEND_TO_PRINT = 'resend_to_print', // DONE
    LINE_ITEM_VALIDATED = 'line_item_validated', // DONE
    DROPPABLE_UPDATE = 'droppable_update' // DONE
}

